var $ = require('jquery');

module.exports = (function() {

  var ajaxAvailability = true;
  var count;

  if ($('body').hasClass('page-template-page_case') && ajaxAvailability) {
    count = $('.case__item-wrapper').length;
    // count is the number of items in the container specified

    if (count === parseInt($('.js-cases-length').val())) {

      $('.case__button').hide();
      count = null;

    }
  }

  $("#ajax__button").click(function() {

    if ($(this).data('pt') === 'news') {

      var postType = 'post';
      var count = $('.news__item-wrapper').length / 2;

      var category = $('.ajax-tabs__tab.-active').data('cat');

      var catLen = 0;
      var val = 0;
      if (category == 'Blogg') {
        val = $('.bloggLength').val();
      }else if (category == 'Nyhet') {
        val = $('.newsLength').val();
      }else{
        val = parseInt($('.newsLength').val()) + parseInt($('.bloggLength').val());
      }

    }
    else {

      var postType = 'cases';
      var count = $('.case__item-wrapper').length;
      var category = '';
    }

    event.preventDefault();

    if (ajaxAvailability) {

      ajaxAvailability = false;

      var count = $('.case__item-wrapper').length;
      // count is the number of items in the container specified
      if( $('.news__item-wrapper').length > 0 ) {
        var count = $('.news__item-wrapper').length / 2;
      }
      $('.case__item-wrapper').css('opacity', '0.5');
     // $('.news__item-wrapper').css('opacity', '0.5');
      $('#js-ajax-loading').css('display', 'inline-block');

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          'action': 'get_cases',
          'ticker': count,
          'postType': postType,
          'category': category
        },
        success:function(data) {

          $('.feed__list').append(data);
          $('.case__item-wrapper').css('opacity', '1');
         // $('.news__item-wrapper').css('opacity', '1');
          $('#js-ajax-loading').hide();

          count = $('.case__item-wrapper').length;
          // count is the number of items in the container specified
          if( $('.news__item-wrapper').length > 0 ) {
            count = $('.news__item-wrapper').length;
          }

          if (count === parseInt($('.js-cases-length').val()) || (count > 0 && count === parseInt(val))) {

            $('.case__button').hide();
            $('.news__button').hide();

          }

          ajaxAvailability = true;

        }

      });

    }

  });

})();



// WEBPACK FOOTER //
// ./components/load_more.js